/**
 * Opuliss Collection Mobile - Inline Filter/Sort (Sturm-style)
 * Converts Wonder theme's drawer filter into inline accordion on phones.
 * Breakpoint: 767px and below.
 *
 * KEY DESIGN: All custom elements are inserted OUTSIDE #ProductGridContainer
 * (inside collection-section, between the aside and the section.collection__body)
 * so they survive the AJAX innerHTML replacement that facets.js does.
 *
 * The filter aside (.wt-filter) already lives outside ProductGridContainer,
 * so it also survives AJAX. We just restyle it inline.
 */
(function () {
  'use strict';

  var BREAKPOINT = 767;
  var initialized = false;
  var refineBtn = null;
  var sortBtn = null;
  var sortDropdown = null;
  var opmToolbar = null;
  var aside = null;

  function isMobile() {
    return window.innerWidth <= BREAKPOINT;
  }

  function init() {
    if (initialized) return;

    aside = document.querySelector('.collection__aside.wt-filter');
    var collectionSection = document.querySelector('collection-section');
    var productGridContainer = document.getElementById('ProductGridContainer');

    if (!aside || !collectionSection || !productGridContainer) return;

    // -- Build the REFINE BY button --
    refineBtn = document.createElement('button');
    refineBtn.className = 'opm-refine-btn';
    refineBtn.setAttribute('type', 'button');
    refineBtn.setAttribute('aria-expanded', 'false');
    refineBtn.innerHTML = '<span class="opm-refine-btn__text">REFINE BY</span><span class="opm-refine-btn__chevron">&#8964;</span>';

    // -- Build the SORT BY button --
    sortBtn = document.createElement('button');
    sortBtn.className = 'opm-sort-btn';
    sortBtn.setAttribute('type', 'button');
    sortBtn.setAttribute('aria-expanded', 'false');
    updateSortButtonLabel();

    // -- Build sort dropdown --
    sortDropdown = document.createElement('div');
    sortDropdown.className = 'opm-sort-dropdown';
    sortDropdown.style.display = 'none';
    buildSortOptions();

    // -- Build the inline toolbar --
    opmToolbar = document.createElement('div');
    opmToolbar.className = 'opm-toolbar';
    opmToolbar.appendChild(refineBtn);
    opmToolbar.appendChild(sortBtn);

    // -- Insert OUTSIDE ProductGridContainer --
    // DOM order: aside (existing) -> opmToolbar (new) -> sortDropdown (new) -> section.collection__body
    // Insert toolbar and sort dropdown BEFORE ProductGridContainer (the section element)
    if (isMobile()) {
      productGridContainer.parentNode.insertBefore(opmToolbar, productGridContainer);
      productGridContainer.parentNode.insertBefore(sortDropdown, productGridContainer);
      aside.classList.add('opm-filter-inline');
    }

    // -- REFINE BY toggle --
    refineBtn.addEventListener('click', function () {
      var isOpen = aside.classList.contains('opm-filter--open');
      if (isOpen) {
        aside.classList.remove('opm-filter--open');
        refineBtn.setAttribute('aria-expanded', 'false');
        refineBtn.classList.remove('opm-refine-btn--open');
      } else {
        aside.classList.add('opm-filter--open');
        refineBtn.setAttribute('aria-expanded', 'true');
        refineBtn.classList.add('opm-refine-btn--open');
        // Close sort if open
        sortDropdown.style.display = 'none';
        sortBtn.setAttribute('aria-expanded', 'false');
        sortBtn.classList.remove('opm-sort-btn--open');
      }
      updateRefineLabel();
    });

    // -- SORT BY toggle --
    sortBtn.addEventListener('click', function () {
      var isOpen = sortDropdown.style.display !== 'none';
      if (isOpen) {
        sortDropdown.style.display = 'none';
        sortBtn.setAttribute('aria-expanded', 'false');
        sortBtn.classList.remove('opm-sort-btn--open');
      } else {
        sortDropdown.style.display = 'block';
        sortBtn.setAttribute('aria-expanded', 'true');
        sortBtn.classList.add('opm-sort-btn--open');
        // Close refine if open
        aside.classList.remove('opm-filter--open');
        refineBtn.setAttribute('aria-expanded', 'false');
        refineBtn.classList.remove('opm-refine-btn--open');
        updateRefineLabel();
      }
    });

    // -- Prevent original drawer behavior on mobile --
    document.body.addEventListener('click', function (e) {
      if (!isMobile()) return;
      if (e.target.closest('.collection__filter-trigger')) {
        e.stopPropagation();
        e.preventDefault();
        refineBtn.click();
      }
    }, true);

    // -- Listen for facets:change to update state after AJAX reload --
    document.addEventListener('facets:change', function () {
      if (!isMobile()) return;
      // Clean up any scroll locks left by destroyed custom-select or drawer
      document.body.removeAttribute('custom-select-opened');
      document.body.classList.remove('page-overlay-on');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      // Re-read sort value after AJAX
      updateSortButtonLabel();
      buildSortOptions();
      updateRefineLabel();
    });

    // -- Handle resize --
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (isMobile()) {
          if (!opmToolbar.parentNode) {
            var pgc = document.getElementById('ProductGridContainer');
            if (pgc && pgc.parentNode) {
              pgc.parentNode.insertBefore(opmToolbar, pgc);
              pgc.parentNode.insertBefore(sortDropdown, pgc);
            }
          }
          aside.classList.add('opm-filter-inline');
        } else {
          if (opmToolbar.parentNode) opmToolbar.parentNode.removeChild(opmToolbar);
          if (sortDropdown.parentNode) sortDropdown.parentNode.removeChild(sortDropdown);
          aside.classList.remove('opm-filter-inline', 'opm-filter--open');
        }
      }, 150);
    });

    initialized = true;
  }

  function updateSortButtonLabel() {
    if (!sortBtn) return;
    // Read current sort from the hidden SortBy input or from custom-select
    var sortInput = document.getElementById('SortBy');
    var currentVal = sortInput ? sortInput.value : '';
    // Try to get human-readable label from the original options
    var toolbar = document.querySelector('.collection__toolbar');
    var options = toolbar ? toolbar.querySelectorAll('.wt-options__list__item') : [];
    var label = 'RELEVANCE';
    options.forEach(function (opt) {
      if (opt.getAttribute('value') === currentVal || opt.hasAttribute('selected')) {
        label = opt.textContent.trim().toUpperCase();
      }
    });
    // Also check the custom-select displayed value
    var displayedVal = toolbar ? toolbar.querySelector('.wt-options__value') : null;
    if (displayedVal && displayedVal.textContent.trim()) {
      label = displayedVal.textContent.trim().toUpperCase();
    }
    sortBtn.innerHTML =
      '<span class="opm-sort-btn__label">SORT BY:</span> <span class="opm-sort-btn__value">' +
      label +
      '</span><span class="opm-sort-btn__chevron">&#8964;</span>';
  }

  function buildSortOptions() {
    if (!sortDropdown) return;
    var toolbar = document.querySelector('.collection__toolbar');
    var existingOptions = toolbar ? toolbar.querySelectorAll('.wt-options__list__item') : [];
    // Clear existing
    sortDropdown.innerHTML = '';
    var sortList = document.createElement('ul');
    sortList.className = 'opm-sort-list';

    existingOptions.forEach(function (opt) {
      var li = document.createElement('li');
      li.className = 'opm-sort-item';
      li.textContent = opt.textContent.trim();
      li.setAttribute('data-value', opt.getAttribute('value') || '');
      if (opt.hasAttribute('selected')) {
        li.classList.add('opm-sort-item--active');
      }
      li.addEventListener('click', function () {
        // Click the original hidden option
        opt.click();

        // CRITICAL: Clean up scroll locks that Wonder theme's custom-select
        // and collection-section leave on body. opt.click() triggers
        // custom-select.toggleState() which OPENS the hidden select (adding
        // body[custom-select-opened]), then AJAX re-render destroys the
        // custom-select DOM so it can never close itself and remove the attr.
        // Same risk with page-overlay-on from the drawer JS.
        document.body.removeAttribute('custom-select-opened');
        document.body.classList.remove('page-overlay-on');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';

        // Update button text
        var valueSpan = sortBtn.querySelector('.opm-sort-btn__value');
        if (valueSpan) valueSpan.textContent = li.textContent.toUpperCase();
        // Update active state
        sortList.querySelectorAll('.opm-sort-item--active').forEach(function (el) {
          el.classList.remove('opm-sort-item--active');
        });
        li.classList.add('opm-sort-item--active');
        // Close dropdown
        sortDropdown.style.display = 'none';
        sortBtn.setAttribute('aria-expanded', 'false');
        sortBtn.classList.remove('opm-sort-btn--open');
      });
      sortList.appendChild(li);
    });
    sortDropdown.appendChild(sortList);
  }

  function updateRefineLabel() {
    if (!refineBtn) return;
    var textSpan = refineBtn.querySelector('.opm-refine-btn__text');
    if (!textSpan) return;

    // Count checked filter inputs
    var checkedInputs = document.querySelectorAll(
      '#FacetFiltersForm input[type="checkbox"]:checked'
    );
    var count = checkedInputs.length;

    // Also check for active price range
    var priceMin = document.querySelector('#FacetFiltersForm input[name="filter.v.price.gte"]');
    var priceMax = document.querySelector('#FacetFiltersForm input[name="filter.v.price.lte"]');
    if (priceMin && parseFloat(priceMin.value) > 0) count++;
    if (priceMax && priceMax.value && priceMax.getAttribute('max') &&
        parseFloat(priceMax.value) < parseFloat(priceMax.getAttribute('max'))) count++;

    if (count > 0) {
      textSpan.textContent = 'REFINE BY (' + count + ')';
    } else {
      textSpan.textContent = 'REFINE BY';
    }
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(init, 100);
    });
  } else {
    setTimeout(init, 100);
  }
})();
